export enum CompanyAvailabilityDayOfWeek {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
}

export const CompanyAvailabilityDayOfWeekLabel: Record<
  CompanyAvailabilityDayOfWeek,
  string
> = {
  MONDAY: 'Segunda-feira',
  TUESDAY: 'Terça-feira',
  WEDNESDAY: 'Quarta-feira',
  THURSDAY: 'Quinta-feira',
  FRIDAY: 'Sexta-feira',
  SATURDAY: 'Sábado',
  SUNDAY: 'Domingo',
};

export interface CompanyAvailabilityCreateRequest {
  capacity: number;
  closingHour: string;
  companyId: number;
  dayOfWeek: CompanyAvailabilityDayOfWeek;
  intervalClosingHour: string;
  intervalOpeningHour: string;
  openingHour: string;
}

export interface CompanyAvailabilityListRequest {
  companyId?: number;
  login?: string;
  matrixId?: number;
  nextToken?: string;
  offset?: number;
  order?: 'ASC' | 'DESC';
  rows?: number;
}

export interface CompanyAvailability {
  capacity: number;
  capsCode: string;
  closingHour: string;
  companyId: number;
  createdAt: string;
  dayOfWeek: CompanyAvailabilityDayOfWeek;
  id: number;
  intervalClosingHour?: string;
  intervalOpeningHour?: string;
  openingHour: string;
}

export interface CompanyAvailabilityListResponse {
  data: CompanyAvailability[];
  nextToken?: string;
}

export interface CompanyAvailabilityEditRequest {
  id: number;
  capacity: number;
  closingHour: string;
  dayOfWeek: CompanyAvailabilityDayOfWeek;
  intervalClosingHour: string;
  intervalOpeningHour: string;
  openingHour: string;
}
